import React, { useState, useEffect, useContext, createContext } from "react";
// import * as firebase from "firebase/app";
// import "firebase/auth";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import env from "../../../env";

// Firebase configuration (defined here to avoid circular dependency)
const firebaseSettings = {
  apiKey: "AIzaSyBG3QvbQIKcdg1nSuTFypu759gzDT0ENIE",
  authDomain: "abna-39c97.firebaseapp.com",
  projectId: "abna-39c97",
  storageBucket: "abna-39c97.firebasestorage.app",
  messagingSenderId: "169461867950",
  appId: "1:169461867950:web:52c3aa1c69c62da2ca143f",
  measurementId: "G-F816HEQPR3"
};

// Initialize Firebase if not already initialized
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseSettings);
}

const authContext = createContext();

// Provider component that wraps your app and makes auth object ...
// ... available to any child component that calls useAuth().
export function ProvideAuth({ children }) {
  const auth = useProvideAuth();
  return <authContext.Provider value={auth}>{children}</authContext.Provider>;
}

// Hook for child components to get the auth object ...
// ... and re-render when it changes.
export const useAuth = () => {
  return useContext(authContext);
};

// Removed fetchUserProfileAndRoles - not needed
// MemberType and roles are now fetched directly in login component via GetUserByEmail API

// Provider hook that creates auth object and handles state
function useProvideAuth() {
  const [user, setUser] = useState(null);
  const [session, setSession] = useState(null);

  const [userV2, setUserV2] = useState(null);
  const [sessionV2, setSessionV2] = useState(null);



  // Wrap any Firebase methods we want to use making sure ...
  // ... to save the user to state.
  const signin = (email, password) => {
    return firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then(response => {
        //setUser(response.user);
        setUserSession(response.user);
        return response.user;
      });
  };

  const signinV2 = async (email, password) => {
    const response = await firebase.auth().signInWithEmailAndPassword(email, password);
    const firebaseUser = response.user;
    const tokenResult = await firebaseUser.getIdTokenResult();

    // No longer fetching profile/roles here - handled in login component
    const extra = { memberType: undefined, roles: [] };

    const sessionV2 = wrapUser(firebaseUser, tokenResult, extra);
    
    setUserV2(firebaseUser);
    setSessionV2(sessionV2);

    return sessionV2;
  };
  const signup = (email, password) => {
    return firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then(response => {
        //setUser(response.user);
        setUserSession(response.user);
        return response.user;
      });
  };

   const signout = () => {
      return firebase
        .auth()
        .signOut()
        .then(() => {
          setUser(null);
          setSession(null);
        });
    };

  const signoutAdmin = () => {
    return firebase
      .auth()
      .signOut()
      .then(() => {
        setUser(null);
        setSession(null);
        setUserV2(null);
        setSessionV2(null);
      });
  };

  const sendPasswordResetEmail = email => {
    return firebase
      .auth()
      .sendPasswordResetEmail(email)
      .then(() => {
        return true;
      });
  };

  const confirmPasswordReset = (code, password) => {
    return firebase
      .auth()
      .confirmPasswordReset(code, password)
      .then(() => {
        return true;
      });
  };

  async function setUserSession(user) {
    if (!user) {
      setUser(null);
      setSession(null);
      return;
    }
    const tokenResult = await user.getIdTokenResult(/* forceRefresh */ false);
    console.log('setting sessions...', tokenResult.expirationTime);
    // No longer fetching profile/roles here - handled in login component
    let extra = { memberType: undefined, roles: []};
    let session = wrapUser(user, tokenResult, extra);
    setUser(user);
    setSession(session);
    return session;
  }
  
  async function extendSession() {
    console.log('checking sessions...')
    if (session && session.expireAt) {
      if (user) {
        let now = new Date();
        if ((+new Date(session.expireAt)) - +now < 11/*min*/ * 60 * 1000) {
          console.log('extending sessions...')
          const tokenResult = await user.getIdTokenResult(/* forceRefresh */ false);
          let session = wrapUser(user, tokenResult);
          setUser(user);
          setSession(session);
        }
      }
    }
  }

  function wrapUser(user, tokenResult, extra) {
    return {
      uid: user.uid,
      email: user.email,
      displayName: user.displayName,
      photoUrl: user.photoURL,
      emailVerified: user.emailVerified,
      profileCheched: false,
      token: tokenResult ? tokenResult.token : null,
      memberType: extra.memberType,
      roles: extra.roles || [],
      //refreshToken: user.refreshToken,
      expireAt: tokenResult ? tokenResult.expirationTime : null,
      expired() {
        return (+new Date(this.expireAt)) - +new Date() < 0
      }
    };
  }  

  // Subscribe to user on mount
  useEffect(() => {
    const unsubscribe = firebase.auth().onAuthStateChanged(user => {
      setUser(user);
      if (user) {
        setUserSession(user);
      } else {
        setUser(null);
        setSession(null);
      }
    });

    return () => unsubscribe();
  }, []);

  React.useEffect(() => {
    if (typeof window !== `undefined`) {
      let timer = setInterval(() => extendSession(), 5/*min*/ * 60 * 1000)
      return () => { clearInterval(timer) }
    }
    // eslint-disable-next-line 
  }, [])

  // Return the user object and auth methods
  return {
    user,
    session,
    userV2,
    sessionV2,
    signin,
    signinV2,
    signup,
    signout,
    signoutAdmin,
    sendPasswordResetEmail,
    confirmPasswordReset
  };
}